// @actionTypes
import {
    FETCH_PROFILE_REQUEST,
    FETCH_PROFILE_SUCCESS,
    FETCH_PROFILE_FAILURE,
} from 'constants/actionTypes';

import { fromJS } from 'immutable';

const setInitialState = () => {
    const prospectBoxConfig = window.okFunds
        ? window.okFunds.messageFundBox
        : null;
    const originCountry =
        window.okFunds && window.okFunds.countryCode
            ? window.okFunds.countryCode.toUpperCase()
            : 'ES';
    const settings =
        window.okFunds && window.okFunds
            ? window.okFunds
            : {
                  isCustomer: true,
                  isLoggedIn: true,
              };
    const noopFunc = () => {
        window.console.log('Function no definida');
    };

    const noopFuncRedirect = () => {
        window.console.log('Function no definida Hire Redirect');
    };

    const noopFuncCustomer = () => {
        window.console.log('Function no definida Customer');
    };

    return fromJS({
        isProspectUser: !settings.isCustomer, //CMS
        isLoggedUser: !!settings.isLoggedIn, //CMS
        isPublicUser: true, //CMS
        displayAccessModal: settings.displayAccessModal || noopFuncCustomer,
        redirectHire: settings.redirectHire || noopFuncRedirect,
        redirectOnBoarding: settings.redirectOnBoarding || noopFunc,
        originCountry: originCountry, //CMS
        prospectNotification: prospectBoxConfig
            ? `<div class="text-formatted">${prospectBoxConfig.text.value}</div>`
            : `<div class="text- formatted"><p><span class="xxs - font"><span class="text - large"><span class="white">Contratar este fondo a través de Openbank no tiene más costes que las comisiones propias del fondo.</span></span></span></p><ul><li><span class="xxs - font"><span class="text - large"><span class="white">Sin comisión de traspaso.</span></span></span></li><li><span class="xxs - font"><span class="text - large"><span class="white">Sin comisión de suscripción.</span></span></span></li><li><span class="xxs - font"><span class="text - large"><span class="white">Sin comisión de custodia.</span></span></span></li><li><span class="xxs - font"><span class="text - large"><span class="white">Sin comisión de reembolso.</span></span></span></li</ul></div>`,
        layoutColor: prospectBoxConfig
            ? `#${prospectBoxConfig.color}`
            : '#E3E9E9',
    });
};

const reducer = (state = setInitialState(), action) => {
    switch (action.type) {
        case FETCH_PROFILE_REQUEST:
            return state;
        case FETCH_PROFILE_SUCCESS:
            return setInitialState();
        case FETCH_PROFILE_FAILURE:
            return state;
        default:
            return state;
    }
};

module.exports = reducer;
